//@ts-nocheck
import { Card, CardBody, Col } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { SOCIAL_DATA_WIDGET } from "../../../../Data/Widgets/GeneralWidgets";
import { H5, Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

const SocialWidgets = () => {
  return (
    <>
      {SOCIAL_DATA_WIDGET.map((data, index) => (
        <Col xl="3" sm="6" key={index}>
          <Card className="social-widget">
            <CardBody>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                  <div className="social-icons">
                    <Image src={dynamicImage(`dashboard/social/${data.image}`)} alt={`${data.title} icon`}/>
                  </div>
                  <span>{data.title}</span>
                </div>
                <span className="font-success f-14 d-xxl-block d-xl-none">+{data.gros}%</span>
              </div>
              <div className="social-content">
                <div>
                  <H5 className="mb-1">{data.total}</H5>
                  <span className="f-light">{data.subTitle}</span>
                </div>
                <div className="social-chart">
                  <ReactApexChart type="radialBar" height={130} series={data.chartData?.series} options={data.chartData.options}/>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default SocialWidgets;
